export const INFRA_TYPE_ANNOTATION = 'infrastructure.backstage.io/type';
export const BUILD_STATUS_ANNOTATION =
  'infrastructure.backstage.io/build-status';
export const IMAGE_FAMILY_ANNOTATION =
  'infrastructure.backstage.io/image-family';
export const SOURCE_REPO_ANNOTATION =
  'infrastructure.backstage.io/source-repo';

export const INFRA_TYPE_IMAGE_BUILD = 'gcp-image-build';
export const INFRA_TYPE_IMAGE_LAUNCH = 'gcp-image-launch';

/** Repo-root image values filename (must match backend portal-manifest.ts). */
export const IMAGE_VALUES_FILENAME = 'image-values.yaml';

/** @deprecated Use IMAGE_VALUES_FILENAME */
export const PORTAL_MANIFEST_FILENAME = IMAGE_VALUES_FILENAME;

export const IMAGE_LAUNCH_TEMPLATE_PATH =
  '/create/templates/default/gcp-image-launch';

export function imageLaunchUrl(imageBuildEntityRef: string): string {
  const formData = encodeURIComponent(
    JSON.stringify({ image_build: imageBuildEntityRef }),
  );
  return `${IMAGE_LAUNCH_TEMPLATE_PATH}?formData=${formData}`;
}
